import { useMemo } from 'react';
import { useI18n } from '../i18n/I18nContext';
import { getNavigationForRole } from '../config/navigation';

/**
 * Hook to get translated navigation items for the current user's role
 * @param {string} role - User role
 * @param {Object} options - Additional options like pending count for badges
 * @returns {Array} Translated navigation items
 */
export function useNavigation(role, options = {}) {
  const { t } = useI18n();
  const { pendingCount = 0 } = options;

  const navItems = useMemo(() => {
    const items = getNavigationForRole(role);

    return items.map(item => ({
      ...item,
      label: t(item.labelKey),
      badge: item.showBadge ? pendingCount : undefined,
    }));
  }, [role, t, pendingCount]);

  return navItems;
}

export default useNavigation;
